import { localizePath } from '~/utils/locales'
import { useSiteLocale } from '~/composables/useSiteLocale'

export const useLocalizedRoute = () => {
  const currentSiteLocale = useSiteLocale()
  
  const getCurrentLocale = () => {
    return currentSiteLocale.value
  }
  
  const getLocalizedPath = (path: string) => {
    const currentLocale = getCurrentLocale()
    return localizePath(path, currentLocale)
  }
  
  const navigateToLocalized = async (path: string) => {
    const localizedPath = getLocalizedPath(path)
    await navigateTo(localizedPath)
  }
  
  return {
    getCurrentLocale,
    getLocalizedPath,
    navigateToLocalized
  }
}
